import React, { useState } from 'react';
import styles from './index.modules.scss';
import { copy } from '@shakkerai/util-copy';
import { Text, notifySuccess } from '@shakkerai/pro-components';
import { translate } from '@shakkerai/util-i18n';

export const PromptInput = (props) => {
  const { title, value, fold = false, defaultExpand = true, toastSuccessContent, ...rest } = props;

  const [expanded, setExpanded] = useState(defaultExpand);

  return (
    <div className={styles.promptInput} {...rest}>
      <div className={styles.title}>
        <div className={styles.topLeftC}>
          <Text size="12" color="var(--color-subsidiary-font)">
            {title}
          </Text>
        </div>
        <div className="flex">
          <Text
            size={12}
            iconClass="icon-proprompt"
            color="var(--color-subsidiary-font)"
            onClick={() => copy(value).then(() => notifySuccess(toastSuccessContent))}
          >
            {translate('copy')}
          </Text>
          {fold && (
            <Text
              size={12}
              iconClass={`icon-border_up ml-3 ${expanded ? 'rotate-0' : 'rotate-180'}`}
              color="var(--color-subsidiary-font)"
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? translate('collapse') : translate('expand')}
            </Text>
          )}
        </div>
      </div>

      {expanded && <div className={`${styles.textarea} select-text`}>{value}</div>}
    </div>
  );
};
